import { render, staticRenderFns } from "./purchase-project-list.html?vue&type=template&id=4850467a&scoped=true&external"
import script from "./purchase-project-list.js?vue&type=script&lang=js&external"
export * from "./purchase-project-list.js?vue&type=script&lang=js&external"
import style0 from "./purchase-project-list.scss?vue&type=style&index=0&id=4850467a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4850467a",
  null
  
)

export default component.exports